
<template>
  <v-container fluid>
    <one-project></one-project>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import OneProject from '../../components/projects/OneProject.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'OneProjectPage',
  //mixins: [ validations ],
  components: {
    OneProject
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>